import { RefreshCw, ShieldAlert } from 'lucide-react'
import { Fragment } from 'react'

import { Button } from '@krp/ui-kit'

import '../../../shared/ui/aqsi.css'
import { QueryState } from '@krp/sale-ui'
import { StateBadge } from '@krp/sale-ui'
import '@krp/sale-ui/sale.css'
import './incidents.css'
import type { RecoveryProofActions, RecoveryProofVm } from '../model/types'

/**
 * Доказательство восстановления продажи (C4b): что служба знает о чеке по своему
 * журналу. Это объяснение, а не разрешение: повторить чек отсюда нельзя — такой
 * кнопки нет; ручная сверка — окно сверки с причиной.
 */
export function RecoveryProofScreen({ vm, actions }: { vm: RecoveryProofVm; actions: RecoveryProofActions }) {
  return (
    <section className="aqsi-screen" aria-labelledby="aqsi-proof-title">
      <header className="aqsi-toolbar">
        <h2 id="aqsi-proof-title">Доказательство восстановления</h2>
        <Button variant="ghost" icon={<RefreshCw size={16} aria-hidden="true" />} onClick={actions.reload}>
          Обновить
        </Button>
      </header>
      <QueryState query={vm.query} what="Доказательство" emptyText="Доказательства нет" onRetry={actions.reload} />
      {vm.outcome !== null && (
        <>
          <StateBadge badge={vm.outcome} />
          <p className="aqsi-card__text">{vm.evidenceText}</p>
          <p className="aqsi-card__state">Что делать: {vm.nextText}</p>
          <dl className="aqsi-facts aqsi-proof__facts" aria-label="Реквизиты доказательства">
            {vm.facts.map((fact) => (
              <Fragment key={fact.label}>
                <dt>{fact.label}</dt>
                <dd>{fact.value}</dd>
              </Fragment>
            ))}
          </dl>
        </>
      )}
      <div className="aqsi-card__actions">
        {vm.manualOperationId !== null && (
          <Button variant="primary" icon={<ShieldAlert size={14} aria-hidden="true" />} onClick={actions.openManualResolve}>
            Ручная сверка
          </Button>
        )}
        <Button variant="ghost" onClick={actions.close}>
          Закрыть
        </Button>
      </div>
    </section>
  )
}
